<nz-form-item>
  <nz-form-label [nzRequired]="to.required">
    {{ to.label }}
  </nz-form-label>
  <nz-form-control [nzErrorTip]="errorTpl" [nzValidateStatus]="errorState">
    <nz-date-picker
      class="custom-date-picker"
      [formControl]="formControl"
      [nzFormat]="to['format']"
      [nzShowTime]="
        to['showTime'] ? { nzDefaultOpenValue: currentDateTime } : false
      "
      [nzPlaceHolder]="to.placeholder || ''"
      [nzShowNow]="false"
    ></nz-date-picker>

    <ng-template #errorTpl let-control>
      <formly-validation-message [field]="field"></formly-validation-message>
    </ng-template>
  </nz-form-control>
</nz-form-item>
